
































import {Component, Vue, Prop} from "vue-property-decorator";

@Component({
  name: 'LoadingDroppo',
  components: {
  },
})
export default class LoadingDroppo extends Vue {
  @Prop({default: false})
  private finish!: boolean;
}
